// Slice das premissas do escritório (spec-017) — take rates, cashback,
// alocações, fee, giro, ROA e taxa padrão que o engine usa para calcular.
//
// Mora em arquivo próprio por ser uma unidade nova e autocontida (state,
// getters, mutations e actions no mesmo lugar), mas é MESCLADO no namespace
// `feeFixo` por `store/index.js`: as chaves ficam planas — `feeFixo/premissas`,
// igual a `feeFixo/dashboard` —, e não num segundo nível `feeFixo/premissas/…`.
//
// Quem carrega e grava é `api/apiFeeFixoPremissas`; as actions daqui só fazem
// commit, como as do resto do módulo.
//
// ⚠️ O default AAWZ NÃO mora aqui. O state nasce vazio de propósito
// (ADR-017-A): premissa que não veio do backend precisa ser um estado
// reconhecível — `premissasCarregadas === false` — e não um número plausível.
// Semear o `DEF` local recriaria a cópia que a spec-017 existe para eliminar, e
// o consumidor calcularia com o default achando que era a premissa do
// escritório.

// Grava data + timestamp. Mesma regra do `setData` de `mutations.js`: o
// `lastUpdate` é o que a camada de API lê como cache.
const gravar = (slice, payload) => {
  if (payload && typeof payload === 'object') {
    slice.data = payload
    slice.lastUpdate = new Date()
  }
}

const slice = (data) => ({ loading: false, lastUpdate: null, data })

export const state = () => ({
  // `data` espelha o `value` do contrato (`contracts/api.yaml`), mas com as
  // chaves já traduzidas para o vocabulário curto do engine — a tradução
  // acontece na borda (camada de API), não aqui.
  premissas: slice({ premissas: {}, origem: {}, tem_customizacao: false }),
  // Trilha de auditoria (US-6), mais recente primeiro conforme o backend enviar.
  premissasHistorico: slice([]),
})

const dados = (state) => state.premissas.data || {}

export const getters = {
  // Envelope inteiro — é o que a camada de API guarda e devolve do cache.
  premissasResolvidas: (state) => dados(state),
  // O que o engine consome: mapa de valores no vocabulário curto do `DEF`.
  premissas: (state) => dados(state).premissas || {},
  // Por campo: 'aawz' (default) ou 'escritorio' (customizado) — é o que
  // permite rotular o número na tela, no PDF e na declaração da IA.
  premissasOrigem: (state) => dados(state).origem || {},
  premissasTemCustomizacao: (state) => !!dados(state).tem_customizacao,
  // "Já veio do backend?" — distingue carga ausente de carga vazia. Sem essa
  // distinção o cálculo seguiria com `{}` e entregaria número errado calado.
  premissasCarregadas: (state) =>
    Object.keys(dados(state).premissas || {}).length > 0,
  premissasLoading: (state) => state.premissas.loading,
  premissasLastUpdate: (state) => state.premissas.lastUpdate,

  premissasHistorico: (state) => state.premissasHistorico.data || [],
  premissasHistoricoLoading: (state) => state.premissasHistorico.loading,
  premissasHistoricoLastUpdate: (state) => state.premissasHistorico.lastUpdate,
}

export const mutations = {
  SET_PREMISSAS: (state, payload) => gravar(state.premissas, payload),
  SET_PREMISSAS_LOADING: (state, payload) => {
    state.premissas.loading = !!payload
  },
  SET_PREMISSAS_HISTORICO: (state, payload) =>
    gravar(state.premissasHistorico, payload),
  SET_PREMISSAS_HISTORICO_LOADING: (state, payload) => {
    state.premissasHistorico.loading = !!payload
  },
}

export const actions = {
  setPremissas: ({ commit }, payload) => commit('SET_PREMISSAS', payload),
  setPremissasLoading: ({ commit }, payload) =>
    commit('SET_PREMISSAS_LOADING', payload),
  setPremissasHistorico: ({ commit }, payload) =>
    commit('SET_PREMISSAS_HISTORICO', payload),
  setPremissasHistoricoLoading: ({ commit }, payload) =>
    commit('SET_PREMISSAS_HISTORICO_LOADING', payload),
}
